import React from 'react';
import PreferencesMain from './PreferencesMain';
import { connect } from 'react-redux';

import BCLLoading from '../../../../components/common/Loading/BCLLoading';

class PreferencesContainer extends React.Component {
  render() {
    return (
      <>
        {this.props.configs && this.props.userObject && this.props.translations ? <PreferencesMain userDetails={this.props.userObject}  configs={this.props.configs} translations={this.props.translations} queryParams={this.props.queryParams} /> : <BCLLoading />}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    userIdentityDetails: state.userIdentityDetails,
    userObject: state.userObject,
    configs: state.configs,
    translations: state.translationsData,
    queryParams: state.queryParams
  };
};

export default connect(mapStateToProps)(PreferencesContainer);
